if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						// Case-multiple lines (step="N"): send the nearest valid multiple, 0 still removes.
						if ( typeof window.snapQuantity === 'function' && window.quantityStep(qty) > 1 ) {
							qty.value = window.snapQuantity(qty, qty.value);
						}
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

			setTimeout(() => {
				if (typeof window.refreshHatchetCartShippingRates === 'function') {
					window.refreshHatchetCartShippingRates();
				}
			}, 20);

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						});
		  		}, 150)
				);
      }
    }
  );
}

if ( ! customElements.get('cart-discounts' ) ) {
	customElements.define(
		'cart-discounts',
		class CartDiscounts extends HTMLElement {

			constructor() {
				super();

				const button = this.querySelector('[data-js-discount-submit]');
				this.input = this.querySelector('[data-js-discount-input]');
				this.cartSubtotal = document.getElementById('AjaxCartSubtotal');
				this.cartDiscountError = this.querySelector('[data-js-discount-error]');
				this.discountCodes = document.querySelector('[data-js-discount-codes]');

				this.loadDiscountButtons();

				button.addEventListener('click', (e) => {
					e.preventDefault();
					if ( this.input.value.length > 0 ) {

						this.cartSubtotal.classList.add('processing');
						if (this.discountCodes) {
							this.discountCodes.classList.add('processing');
						}

						const existingDiscounts = Array.from(this.querySelectorAll('[data-js-discount]')).map(elm => elm.dataset.jsDiscount);
						
						const allDiscounts = [...existingDiscounts, this.input.value];
						const discountString = allDiscounts.join(',');
						const body = JSON.stringify({ discount: discountString });

						fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						})
							.then(response => response.json())
							.then(response => {
								const discountCodes = response.discount_codes;
								const inputValue = this.input.value;
								const matchingCode = discountCodes.find(code => 
									code.code === inputValue
								);

								if (matchingCode) {
									if (matchingCode.applicable) {
										this.handleSuccess();
									} else {
										this.handleError();
									}
								} else {
									this.handleError();
								}
							})
							.catch(error => {
								this.handleError();
								console.log(`Error: ${error}`);
							})

					}

				});

			}

			handleSuccess(){
				fetch('?section_id=helper-cart')
					.then(response => response.text())
					.then(text => {
						const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
						const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
						this.cartSubtotal.innerHTML = cartSubtotalInnerHTML;
						this.cartSubtotal.classList.remove('processing');
						this.cartDiscountError.innerHTML = '';
						if ( sectionInnerHTML.querySelector('[data-js-discount-codes]') ) {
							this.discountCodes.innerHTML = sectionInnerHTML.querySelector('[data-js-discount-codes]').innerHTML;
							this.discountCodes.classList.remove('processing');
							this.loadDiscountButtons();
						}
						this.input.value = '';
					})
			}

			loadDiscountButtons(){
				this.querySelectorAll('[data-js-discount]').forEach(elm=>{
					if ( ! elm.classList.contains('enabled') ) {
						elm.classList.add('enabled');
						elm.addEventListener('click', (e)=>{
							e.preventDefault();
							this.cartSubtotal.classList.add('processing');
							if (this.discountCodes) {
								this.discountCodes.classList.add('processing');
							}
							const discountToRemove = elm.dataset.jsDiscount;
							
							const allDiscountElements = this.querySelectorAll('[data-js-discount]');
							const allDiscounts = Array.from(allDiscountElements).map(el => el.dataset.jsDiscount);
							
							const remainingDiscounts = allDiscounts.filter(discount => discount !== discountToRemove);
							
							const body = JSON.stringify({ 
								discount: remainingDiscounts.join(',') 
							});
							
							fetch(`${KROWN.settings.routes.cart_update_url}`, { 
								method: 'POST',
								headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
								body 
							})
								.then(() => {
									this.handleSuccess();
								})
								.catch(error => {
									console.error(`Error: ${error}`);
								});
						});
					}
				});
			}
			
			handleError(){
				this.cartSubtotal.classList.remove('processing');
				if (this.discountCodes) {
					this.discountCodes.classList.remove('processing');
				}
				this.cartDiscountError.innerHTML = window.KROWN.settings.locales.cart_discount_code_error;
			}

		}	
	)
}

(function() {
	const STORE_ZIPS = {
		'nassau': '12123',
		'brunswick': '12180',
		'downtown-troy': '12180',
		'waterford': '12188',
		'palatine-bridge': '13428',
		'niskayuna': '12309',
		'wynantskill': '12198',
		'colonie': '12205',
		'coxsackie': '12192'
	};

	const STORE_NAMES = {
		'nassau': 'Nassau',
		'brunswick': 'Brunswick',
		'downtown-troy': 'Downtown Troy',
		'waterford': 'Waterford',
		'palatine-bridge': 'Palatine Bridge',
		'niskayuna': 'Niskayuna',
		'wynantskill': 'Wynantskill',
		'colonie': 'Colonie',
		'coxsackie': 'Coxsackie'
	};

	function getActiveStoreDisplayName() {
		try {
			const h = (localStorage.getItem('selected-store') || '').trim().toLowerCase();
			if (STORE_NAMES[h]) return STORE_NAMES[h];
		} catch (_) {}
		return 'Nassau';
	}

	const STATE_NAMES_BY_CODE = {
		AL:'Alabama', AK:'Alaska', AZ:'Arizona', AR:'Arkansas', CA:'California', CO:'Colorado', CT:'Connecticut',
		DE:'Delaware', DC:'District of Columbia', FL:'Florida', GA:'Georgia', HI:'Hawaii', ID:'Idaho', IL:'Illinois',
		IN:'Indiana', IA:'Iowa', KS:'Kansas', KY:'Kentucky', LA:'Louisiana', ME:'Maine', MD:'Maryland',
		MA:'Massachusetts', MI:'Michigan', MN:'Minnesota', MS:'Mississippi', MO:'Missouri', MT:'Montana',
		NE:'Nebraska', NV:'Nevada', NH:'New Hampshire', NJ:'New Jersey', NM:'New Mexico', NY:'New York',
		NC:'North Carolina', ND:'North Dakota', OH:'Ohio', OK:'Oklahoma', OR:'Oregon', PA:'Pennsylvania',
		RI:'Rhode Island', SC:'South Carolina', SD:'South Dakota', TN:'Tennessee', TX:'Texas', UT:'Utah',
		VT:'Vermont', VA:'Virginia', WA:'Washington', WV:'West Virginia', WI:'Wisconsin', WY:'Wyoming'
	};

	function inferStateNameFromZip(zip, stateHint) {
		const code = String(stateHint || '').trim().toUpperCase();
		if (STATE_NAMES_BY_CODE[code]) return STATE_NAMES_BY_CODE[code];
		if (Object.values(STATE_NAMES_BY_CODE).includes(stateHint)) return stateHint;
		const p = parseInt(String(zip || '').slice(0, 3), 10);
		if (!Number.isFinite(p)) return 'New York';
		if (p >= 10 && p <= 27) return 'Massachusetts';
		if (p >= 28 && p <= 29) return 'Rhode Island';
		if (p >= 30 && p <= 38) return 'New Hampshire';
		if (p >= 39 && p <= 49) return 'Maine';
		if (p >= 50 && p <= 59) return 'Vermont';
		if (p >= 60 && p <= 69) return 'Connecticut';
		if (p >= 70 && p <= 89) return 'New Jersey';
		if (p >= 100 && p <= 149) return 'New York';
		if (p >= 150 && p <= 196) return 'Pennsylvania';
		if (p >= 197 && p <= 199) return 'Delaware';
		if (p === 200 || (p >= 202 && p <= 205)) return 'District of Columbia';
		if (p >= 206 && p <= 219) return 'Maryland';
		if ((p >= 201 && p <= 201) || (p >= 220 && p <= 246)) return 'Virginia';
		if (p >= 247 && p <= 268) return 'West Virginia';
		if (p >= 270 && p <= 289) return 'North Carolina';
		if (p >= 290 && p <= 299) return 'South Carolina';
		if (p >= 300 && p <= 319) return 'Georgia';
		if (p >= 320 && p <= 349) return 'Florida';
		if (p >= 350 && p <= 369) return 'Alabama';
		if (p >= 370 && p <= 385) return 'Tennessee';
		if (p >= 386 && p <= 397) return 'Mississippi';
		if (p >= 400 && p <= 427) return 'Kentucky';
		if (p >= 430 && p <= 459) return 'Ohio';
		if (p >= 460 && p <= 479) return 'Indiana';
		if (p >= 480 && p <= 499) return 'Michigan';
		if (p >= 500 && p <= 528) return 'Iowa';
		if (p >= 530 && p <= 549) return 'Wisconsin';
		if (p >= 550 && p <= 567) return 'Minnesota';
		if (p >= 570 && p <= 577) return 'South Dakota';
		if (p >= 580 && p <= 588) return 'North Dakota';
		if (p >= 590 && p <= 599) return 'Montana';
		if (p >= 600 && p <= 629) return 'Illinois';
		if (p >= 630 && p <= 658) return 'Missouri';
		if (p >= 660 && p <= 679) return 'Kansas';
		if (p >= 680 && p <= 693) return 'Nebraska';
		if (p >= 700 && p <= 714) return 'Louisiana';
		if (p >= 716 && p <= 729) return 'Arkansas';
		if (p >= 730 && p <= 749) return 'Oklahoma';
		if (p >= 750 && p <= 799) return 'Texas';
		if (p >= 800 && p <= 816) return 'Colorado';
		if (p >= 820 && p <= 831) return 'Wyoming';
		if (p >= 832 && p <= 838) return 'Idaho';
		if (p >= 840 && p <= 847) return 'Utah';
		if (p >= 850 && p <= 865) return 'Arizona';
		if (p >= 870 && p <= 884) return 'New Mexico';
		if (p >= 889 && p <= 898) return 'Nevada';
		if (p >= 900 && p <= 961) return 'California';
		if (p >= 970 && p <= 979) return 'Oregon';
		if (p >= 980 && p <= 994) return 'Washington';
		return 'New York';
	}

	function escapeHtml(str) {
		return String(str == null ? '' : str)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}

	function getActiveDeliveryDestination() {
		let zip = '';
		let point = null;
		try {
			zip = (localStorage.getItem('hatchet_delivery_zip') || '').trim().slice(0, 5);
			const rawPoint = localStorage.getItem('hatchet_delivery_point');
			if (rawPoint) point = JSON.parse(rawPoint);
		} catch (_) {}

		if (!/^\d{5}$/.test(zip)) {
			let storeHandle = '';
			try { storeHandle = localStorage.getItem('selected-store') || ''; } catch (_) {}
			zip = STORE_ZIPS[storeHandle] || '12123';
		}

		const pointMatchesZip = point && String(point.postal_code || '').slice(0, 5) === zip;
		const province = inferStateNameFromZip(zip, pointMatchesZip ? point.province : '');
		return {
			zip,
			province,
			address1: pointMatchesZip ? (point.address1 || '') : '',
			city: pointMatchesZip ? (point.city || '') : ''
		};
	}

	function getEtYmd(offsetDays) {
		const now = new Date();
		const et = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
		et.setDate(et.getDate() + (offsetDays || 0));
		const y = et.getFullYear();
		const m = String(et.getMonth() + 1).padStart(2, '0');
		const d = String(et.getDate()).padStart(2, '0');
		return `${y}-${m}-${d}`;
	}

	function formatYmdShort(rawYmd) {
		const ymd = String(rawYmd || '').trim().slice(0, 10);
		if (!ymd || !/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return '';
		const [y, m, d] = ymd.split('-').map(Number);
		const dt = new Date(y, m - 1, d, 12, 0, 0);
		return dt.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
	}

	function formatYmdSlash(rawYmd) {
		const ymd = String(rawYmd || '').trim().slice(0, 10);
		if (!ymd || !/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return '';
		const [y, m, d] = ymd.split('-').map(Number);
		const dt = new Date(y, m - 1, d, 12, 0, 0);
		const wk = dt.toLocaleDateString('en-US', { weekday: 'short' });
		return `${wk} ${m}/${d}`;
	}

	function parseSlashEtaFromDescription(desc, todayYmd, tomorrowYmd) {
		const s = String(desc || '').trim();
		if (!s) return '';
		if (/\btoday\b/i.test(s)) return formatYmdSlash(todayYmd);
		if (/\btomorrow\b/i.test(s)) return formatYmdSlash(tomorrowYmd);
		const m = s.match(/\b(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s+(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s+(\d{1,2})\b/i);
		if (m) {
			const months = { jan:1, feb:2, mar:3, apr:4, may:5, jun:6, jul:7, aug:8, sep:9, oct:10, nov:11, dec:12 };
			const mo = months[m[2].toLowerCase()];
			const wk = m[1].charAt(0).toUpperCase() + m[1].slice(1, 3).toLowerCase();
			if (mo) return `${wk} ${mo}/${parseInt(m[3], 10)}`;
		}
		return '';
	}

	function normalizeRooRates(rawRates) {
		const todayYmd = getEtYmd(0);
		const tomorrowYmd = getEtYmd(1);
		const list = (Array.isArray(rawRates) ? rawRates : []).map(r => {
			const name = String(r.presentment_name || r.name || 'Delivery').trim();
			const code = String(r.code || name).trim();
			const priceNum = parseFloat(String(r.price || '0'));
			const priceCents = Number.isFinite(priceNum) ? Math.round(priceNum * 100) : 0;
			const priceText = priceCents === 0 ? 'Free' : '$' + (priceCents / 100).toFixed(2);
			const rawDate = r.delivery_date || (Array.isArray(r.delivery_range) ? (r.delivery_range[1] || r.delivery_range[0]) : '') || '';
			const deliveryDate = String(rawDate || '').trim().slice(0, 10);

			let drawerTitle = name;
			if (/same.?day/i.test(name) || /same.?day/i.test(code)) drawerTitle = 'Same-Day';
			else if (/next.?morning/i.test(name) || /next.?morning/i.test(code)) drawerTitle = 'Next-Morning';
			else if (/local.?truck|free local/i.test(name) || /local_truck/i.test(code)) drawerTitle = 'Local Truck';
			else if (/ground/i.test(name) || /ground/i.test(code)) drawerTitle = 'Ground';

			let shortEta = '';
			let longEta = '';
			let slashEta = formatYmdSlash(deliveryDate) || parseSlashEtaFromDescription(r.description, todayYmd, tomorrowYmd);
			if (deliveryDate === todayYmd || /same.?day/i.test(code)) {
				shortEta = 'Today';
				longEta = r.description || 'In stock, delivered today';
				if (!slashEta) slashEta = formatYmdSlash(todayYmd);
			} else if (deliveryDate === tomorrowYmd) {
				shortEta = 'Tomorrow';
				longEta = 'Est. tomorrow';
				if (!slashEta) slashEta = formatYmdSlash(tomorrowYmd);
			} else if (deliveryDate) {
				const fmt = formatYmdShort(deliveryDate);
				shortEta = fmt || r.description || 'Standard';
				longEta = fmt ? `Est. ${fmt}` : (r.description || 'Standard delivery');
			} else {
				shortEta = r.description || 'Standard';
				longEta = r.description || 'Calculated at checkout';
			}

			const isFast = /same.?day|next.?morning/i.test(code);
			return {
				name,
				drawerTitle,
				code,
				priceCents,
				priceText,
				shortEta,
				longEta,
				slashEta,
				deliveryDate,
				isFast
			};
		});

		// Slowest delivery first, fastest last (owner 2026-10-30). An undated rate counts as the
		// slowest. Same date: Same-Day / Next-Morning go after the others, then cheaper first.
		list.sort((a, b) => {
			const aDate = a.deliveryDate || '9999-12-31';
			const bDate = b.deliveryDate || '9999-12-31';
			if (aDate !== bDate) return aDate < bDate ? 1 : -1;
			if (a.isFast !== b.isFast) return a.isFast ? 1 : -1;
			return a.priceCents - b.priceCents;
		});

		return list;
	}

	function updateItemShipEtas(activeRate, destZip) {
		const zipText = escapeHtml(destZip || '12123');
		const slash = activeRate && activeRate.slashEta ? escapeHtml(activeRate.slashEta) : '';
		document.querySelectorAll('[data-js-drawer-item-eta]').forEach(el => {
			if (slash) {
				el.innerHTML = `Expect it by <strong>${slash}</strong> to <strong data-js-cart-zip>${zipText}</strong>`;
			} else {
				el.innerHTML = `Shipping to <strong data-js-cart-zip>${zipText}</strong>`;
			}
		});
		document.querySelectorAll('[data-js-cart-item-ship-eta]').forEach(el => {
			if (slash) {
				el.innerHTML = `Expect it to arrive on <strong>${slash}</strong>`;
			} else {
				el.innerHTML = `Shipping to <strong data-js-cart-zip>${zipText}</strong>`;
			}
		});
	}

	window.formatHatchetMoney = function(cents) {
		return '$' + (Number(cents || 0) / 100).toFixed(2);
	};

	window.updateHatchetCartSummary = function() {
		const holder = document.querySelector('.cart-holder[data-subtotal-cents]');
		const holderCents = holder ? parseInt(holder.getAttribute('data-subtotal-cents') || '0', 10) : null;
		const selectedCards = document.querySelectorAll('.cart-delivery-speed__card.is-selected, [data-js-drawer-delivery-speed] button[aria-pressed="true"]');
		let selectedFeeCents = null;
		selectedCards.forEach(card => {
			const fee = parseInt(card.getAttribute('data-fee-cents') || '', 10);
			if (Number.isFinite(fee) && (selectedFeeCents === null || fee > selectedFeeCents)) {
				selectedFeeCents = fee;
			}
		});

		const anyDeliveryContainer = document.querySelectorAll('[data-js-cart-delivery-speed], [data-js-drawer-delivery-speed]').length > 0;

		document.querySelectorAll('[data-js-summary-delivery]').forEach(deliveryEl => {
			if (!anyDeliveryContainer) {
				deliveryEl.textContent = 'Free (Pickup)';
			} else if (selectedFeeCents === null) {
				deliveryEl.textContent = 'Calculated at checkout';
			} else if (selectedFeeCents === 0) {
				deliveryEl.textContent = 'Free';
			} else {
				deliveryEl.textContent = window.formatHatchetMoney(selectedFeeCents);
			}
		});

		document.querySelectorAll('[data-js-summary-total]').forEach(totalEl => {
			const attrCents = parseInt(totalEl.getAttribute('data-subtotal-cents') || '', 10);
			const baseCents = Number.isFinite(attrCents) ? attrCents : holderCents;
			if (!Number.isFinite(baseCents)) return;
			const addCents = (anyDeliveryContainer && selectedFeeCents !== null) ? selectedFeeCents : 0;
			totalEl.textContent = window.formatHatchetMoney(baseCents + addCents);
		});
	};

	window.selectHatchetDeliverySpeed = function(btn) {
		const code = btn.getAttribute('data-rate-code') || '';
		if (code) {
			try { sessionStorage.setItem('hatchet_selected_rate_code', code); } catch (_) {}
		}

		document.querySelectorAll('[data-js-cart-delivery-speed] .cart-delivery-speed__card').forEach(b => {
			const match = code ? b.getAttribute('data-rate-code') === code : b === btn;
			b.classList.toggle('is-selected', match);
			b.setAttribute('aria-pressed', match ? 'true' : 'false');
		});

		document.querySelectorAll('[data-js-drawer-delivery-speed] button[data-rate-code]').forEach(b => {
			const match = code ? b.getAttribute('data-rate-code') === code : b === btn;
			b.setAttribute('aria-pressed', match ? 'true' : 'false');
			b.style.border = match ? '2px solid #1B4332' : '1.5px solid rgba(17,17,17,0.16)';
			b.style.background = match ? '#FAFDFB' : '#fff';
		});

		const slashEta = btn.getAttribute('data-slash-eta') || '';
		const dest = getActiveDeliveryDestination();
		if (slashEta) {
			updateItemShipEtas({ slashEta }, dest.zip);
		}

		window.updateHatchetCartSummary();
	};

	window.setHatchetCartItemFulfillment = function(lineIndex, mode) {
		const itemEl = document.querySelector(`#AjaxCartForm [data-js-cart-item][data-line="${lineIndex}"]`);
		if (!itemEl) return;
		const qty = parseInt(itemEl.getAttribute('data-qty') || '1', 10) || 1;
		let props = {};
		try {
			const rawProps = itemEl.getAttribute('data-properties');
			if (rawProps) {
				const parsed = JSON.parse(rawProps);
				if (Array.isArray(parsed)) {
					parsed.forEach(pair => {
						if (Array.isArray(pair) && pair.length >= 2) props[pair[0]] = pair[1];
					});
				} else if (parsed && typeof parsed === 'object') {
					props = Object.assign({}, parsed);
				}
			}
		} catch (_) {}

		const currentPickup = String(props['_Pickup Store'] || '').trim();
		if (mode === 'pickup' && currentPickup) return;
		if (mode === 'ship' && !currentPickup) return;

		if (mode === 'pickup') {
			props['_Pickup Store'] = getActiveStoreDisplayName();
		} else {
			props['_Pickup Store'] = '';
		}

		const cartForm = document.getElementById('AjaxCartForm');
		if (cartForm && cartForm.form) cartForm.form.classList.add('processing');

		const changeUrl = (window.KROWN && window.KROWN.settings && window.KROWN.settings.routes && window.KROWN.settings.routes.cart_change_url) || '/cart/change.js';
		fetch(changeUrl, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
			body: JSON.stringify({
				line: parseInt(lineIndex, 10),
				quantity: qty,
				properties: props
			})
		})
			.then(() => fetch('?section_id=helper-cart'))
			.then(r => r.text())
			.then(text => {
				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
				const cartFormInner = sectionInnerHTML.getElementById('AjaxCartForm');
				const cartSubtotalInner = sectionInnerHTML.getElementById('AjaxCartSubtotal');
				if (cartForm && cartFormInner) {
					cartForm.innerHTML = cartFormInner.innerHTML;
					if (typeof cartForm.ajaxifyCartItems === 'function') cartForm.ajaxifyCartItems();
				}
				const subtotalEl = document.getElementById('AjaxCartSubtotal');
				if (subtotalEl && cartSubtotalInner) {
					subtotalEl.innerHTML = cartSubtotalInner.innerHTML;
				}
				if (cartForm) {
					cartForm.dispatchEvent(new Event('cart-updated'));
				}
				window.refreshHatchetCartShippingRates();
			})
			.finally(() => {
				if (cartForm && cartForm.form) cartForm.form.classList.remove('processing');
			});
	};

	window.promptHatchetCartZip = function() {
		const dest = getActiveDeliveryDestination();
		const z = window.prompt('Enter delivery ZIP code:', dest.zip || '12123');
		if (!z) return;
		const clean = z.trim().replace(/\s+/g, '').slice(0, 5);
		if (!/^\d{5}$/.test(clean)) return;
		try {
			localStorage.setItem('hatchet_delivery_zip', clean);
		} catch (_) {}
		document.querySelectorAll('[data-js-cart-zip]').forEach(el => {
			el.textContent = clean;
		});
		window.refreshHatchetCartShippingRates(true);
	};

	function renderRatesIntoContainers(rates) {
		let savedCode = '';
		try { savedCode = sessionStorage.getItem('hatchet_selected_rate_code') || ''; } catch (_) {}

		// Cards run slowest → fastest, so the first one is not always the cheapest — default to the cheapest.
		const cheapestRate = rates.reduce((best, r) => (!best || r.priceCents < best.priceCents ? r : best), null);
		const activeRate = rates.find(r => r.code === savedCode) || cheapestRate;
		const activeCode = activeRate ? activeRate.code : '';
		const dest = getActiveDeliveryDestination();

		updateItemShipEtas(activeRate, dest.zip);

		const truckIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
		const boltIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>';

		document.querySelectorAll('[data-js-drawer-delivery-speed]').forEach(container => {
			if (!rates.length) {
				container.innerHTML = '<div style="grid-column:1 / -1;padding:0.45rem 0.5rem;border:1px solid rgba(17,17,17,0.12);border-radius:6px;background:#FAFBF9;font-size:0.6875rem;color:#4B5563;">Shipping options calculated at checkout</div>';
				return;
			}
			const cols = Math.min(Math.max(rates.length, 1), 3);
			container.style.gridTemplateColumns = `repeat(${cols}, minmax(0, 1fr))`;
			container.innerHTML = rates.map(r => {
				const selected = r.code === activeCode;
				return `
					<button type="button"
						data-rate-code="${escapeHtml(r.code)}"
						data-fee-cents="${r.priceCents}"
						data-slash-eta="${escapeHtml(r.slashEta || '')}"
						aria-pressed="${selected ? 'true' : 'false'}"
						onclick="window.selectHatchetDeliverySpeed(this);"
						style="display:flex;flex-direction:column;justify-content:space-between;min-height:4.25rem;height:100%;padding:0.4rem 0.45rem;border:${selected ? '2px solid #1B4332' : '1.5px solid rgba(17,17,17,0.16)'};border-radius:6px;background:${selected ? '#FAFDFB' : '#fff'};text-align:left;cursor:pointer;box-sizing:border-box;">
						<span style="display:block;font-size:0.6875rem;font-weight:700;color:#111827;line-height:1.2;">${escapeHtml(r.drawerTitle)}</span>
						<span style="display:block;font-size:0.625rem;color:#4B5563;line-height:1.2;">${escapeHtml(r.shortEta)}</span>
						<span style="display:block;margin-top:0.2rem;font-size:0.6875rem;font-weight:800;color:#1B4332;line-height:1.2;">${escapeHtml(r.priceText)}</span>
					</button>
				`;
			}).join('');
		});

		document.querySelectorAll('[data-js-cart-delivery-speed]').forEach(container => {
			if (!rates.length) {
				container.innerHTML = '<div style="grid-column:1 / -1;padding:0.75rem 1rem;border:1px solid rgba(17,17,17,0.12);border-radius:8px;background:#FAFBF9;font-size:0.8125rem;color:#4B5563;">Shipping options calculated at checkout</div>';
				return;
			}
			const cols = Math.min(Math.max(rates.length, 1), 3);
			container.style.setProperty('grid-template-columns', `repeat(${cols}, 168px)`, 'important');
			container.innerHTML = rates.map(r => {
				const selected = r.code === activeCode;
				return `
					<button type="button"
						class="cart-delivery-speed__card${selected ? ' is-selected' : ''}"
						data-rate-code="${escapeHtml(r.code)}"
						data-fee-cents="${r.priceCents}"
						data-slash-eta="${escapeHtml(r.slashEta || '')}"
						data-speed-label="${escapeHtml(r.name)}"
						aria-pressed="${selected ? 'true' : 'false'}"
						onclick="window.selectHatchetDeliverySpeed(this);">
						<span class="cart-delivery-speed__badge" aria-hidden="true">&#10003;</span>
						<span class="cart-delivery-speed__icon" aria-hidden="true">${r.isFast ? boltIcon : truckIcon}</span>
						<span>
							<span class="cart-delivery-speed__title">${escapeHtml(r.name)}</span>
							<span class="cart-delivery-speed__eta">${escapeHtml(r.longEta)}</span>
						</span>
						<span class="cart-delivery-speed__price">${escapeHtml(r.priceText)}</span>
					</button>
				`;
			}).join('');
		});

		window.updateHatchetCartSummary();
	}

	window._hatchetShippingRatesCache = window._hatchetShippingRatesCache || {};

	window.refreshHatchetCartShippingRates = function(forceRefresh) {
		const dest = getActiveDeliveryDestination();
		document.querySelectorAll('[data-js-cart-zip]').forEach(el => {
			el.textContent = dest.zip;
		});
		const storeDisplay = getActiveStoreDisplayName();
		document.querySelectorAll('[data-js-cart-pickup-store-name]').forEach(el => {
			el.textContent = storeDisplay;
		});

		const containers = document.querySelectorAll('[data-js-drawer-delivery-speed], [data-js-cart-delivery-speed], [data-js-drawer-item-eta], [data-js-cart-item-ship-eta]');
		if (!containers.length) {
			window.updateHatchetCartSummary();
			return;
		}

		const itemsSig = Array.from(document.querySelectorAll('#AjaxCartForm [data-js-cart-item]'))
			.map(el => `${el.getAttribute('data-id') || ''}:${el.getAttribute('data-qty') || ''}`)
			.join(',');
		const cacheKey = `${dest.zip}|${dest.province}|${dest.address1}|${itemsSig}`;

		if (!forceRefresh && window._hatchetShippingRatesCache[cacheKey]) {
			renderRatesIntoContainers(window._hatchetShippingRatesCache[cacheKey]);
			return;
		}

		const params = new URLSearchParams();
		params.set('shipping_address[zip]', dest.zip);
		params.set('shipping_address[country]', 'United States');
		params.set('shipping_address[province]', dest.province);
		if (dest.address1) params.set('shipping_address[address1]', dest.address1);
		if (dest.city) params.set('shipping_address[city]', dest.city);

		const cartUrl = (window.KROWN && window.KROWN.settings && window.KROWN.settings.routes && window.KROWN.settings.routes.cart_url) || '/cart';
		fetch(`${cartUrl}/shipping_rates.json?${params.toString()}`, {
			credentials: 'same-origin',
			method: 'GET'
		})
			.then(r => r.json())
			.then(data => {
				if (data && Array.isArray(data.shipping_rates)) {
					const normalized = normalizeRooRates(data.shipping_rates);
					window._hatchetShippingRatesCache[cacheKey] = normalized;
					renderRatesIntoContainers(normalized);
				} else {
					renderRatesIntoContainers([]);
				}
			})
			.catch(() => {
				renderRatesIntoContainers([]);
			});
	};

	document.addEventListener('storechanged', () => {
		const storeDisplay = getActiveStoreDisplayName();
		document.querySelectorAll('[data-js-cart-pickup-store-name]').forEach(el => {
			el.textContent = storeDisplay;
		});
		window.refreshHatchetCartShippingRates();
	}, true);

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => window.refreshHatchetCartShippingRates());
	} else {
		window.refreshHatchetCartShippingRates();
	}
})();